import { INewsMetadata, News, PaginatedResponse, PaginationParams } from '@arpeggi/shared'
import { useAuth } from '../../hooks/useAuth'
import axios from '../../lib/axios'
import { objectToFormData } from '../../utils/api'

export interface GetNewsParams extends PaginationParams<Omit<News, 'metadata' | 'image'>> {}

export interface CreateNewsDto {
  metadata: INewsMetadata
  image: File
}

export interface UpdateNewsDto {
  metadata?: Partial<INewsMetadata>
  image?: File
}

export const getNews = async (params: GetNewsParams) => {
  const { data } = await axios.get<PaginatedResponse<News>>('/api/v2/news', { params })

  return data
}

export const getOneNews = async (id: number) => {
  const { data } = await axios.get<News>(`/api/v2/news/${id}`)

  return data
}

export const useNewsAPI = () => {
  const { authenticatedPatch, authenticatedDelete, authenticatedPost } = useAuth()

  const createNews = async (dto: CreateNewsDto) => {
    const { data } = await authenticatedPost<News>('/api/v2/news', objectToFormData(dto))

    return data
  }

  const updateNews = async ({ id, dto }: { id: number; dto: UpdateNewsDto }) => {
    const { data } = await authenticatedPatch<News>(`/api/v2/news/${id}`, objectToFormData(dto))

    return data
  }

  const deleteNews = async (id: number) => {
    return authenticatedDelete(`/api/v2/news/${id}`)
  }

  return { createNews, updateNews, deleteNews }
}
